/**
 * Bounce rate formatını yüzde olarak düzenler
 * @param {number} rate - Bounce rate değeri
 * @returns {string} - Formatlanmış bounce rate
 */
export function formatBounceRate(rate) {
  return rate ? (rate * 100).toFixed(2) + "%" : "0%";
}

/**
 * Tarihi API için YYYYMMDD formatına dönüştürür
 * @param {Date|Object} date - Dönüştürülecek tarih
 * @returns {string} - YYYYMMDD formatında tarih
 */
export function formatDateForAPI(date) {
  // dayjs objesi kontrolü
  if (date && typeof date.format === "function") {
    return date.format("YYYYMMDD");
  }

  // Date objesi kontrolü
  if (date instanceof Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}${month}${day}`;
  }

  return "";
}

/**
 * YYYYMMDD formatını DD/MM/YYYY formatına dönüştürür
 * @param {string} dateString - YYYYMMDD formatında tarih
 * @returns {string} - DD/MM/YYYY formatında tarih
 */
export function formatDate(dateString) {
  if (!dateString || dateString.length !== 8) return dateString;

  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);

  return `${day}/${month}/${year}`;
}
